<template>
	<div>
		<page-title-bar class="pb-1">
			<template slot="actions">
				<menu-downloads v-if="permisos.descargar"></menu-downloads>
			</template>
		</page-title-bar>
		<v-container fluid pt-0>
			<v-layout row wrap border-rad-sm overflow-hidden>
				<app-card
						colClasses="xs12"
						customClasses="mb-0"
						:fullScreen="true"
						:reloadable="true"
						:closeable="true"
						:fullBlock="true"
						:footer="false"
				>
					<data-table
							ref="tableProgramaciones"
							v-model="dataTable"
							@resetOption="item => resetOptions(item)"
							@anular="item => openDialogCancel(item)"
							@entregar="item => openDialogEntregar(item)"
							@descargarSoporte="item => descargarSoporte(item)"
					></data-table>
				</app-card>
			</v-layout>
		</v-container>
		<confirmation-dialog
				ref="dialogCancel"
				color="error"
				heading="¿Seguro de continuar?"
				:message="`¿Está seguro de anular la programación <strong>${selectedProgramacion ? selectedProgramacion.id : ''}</strong>?`"
				@onConfirm="cancelProgramacion"
				@onCancel="selectedProgramacion = null"
		>
		</confirmation-dialog>
		<detail-technologi-dialog ref="dialogInfoTechnologi" @onProcess="processingTable = false"></detail-technologi-dialog>
		<entrega-programacion-dialog
				ref="dialogEntregaProgramacion"
				:heading="`Registro de entrega, programación No. <strong>${selectedProgramacion ? selectedProgramacion.id : ''}</strong>`"
		>
		</entrega-programacion-dialog>
	</div>
</template>

<script>
    var $this = null
    export default {
        components: {
            EntregaProgramacionDialog: () => import('@/components/Programaciones/EntregaProgramacionDialog'),
            MenuDownloads: () => import('@/components/Programaciones/MenuDownloads')
        },
        data: () => ({
            processingTable: false,
            selectedProgramacion: null,
            dataTable: {
                nameItemState: 'tableProgramaciones',
                route: 'programaciones',
                makeHeaders: [
                    {
                        text: 'ID',
                        align: 'left',
                        sortable: false,
                        visibleColumn: false,
                        value: 'direccionamiento_id'
                    },
                    {
                        text: 'Id programación',
                        align: 'left',
                        sortable: false,
                        value: 'id'
                    },
					{
                        text: 'Fecha',
                        tooltip: 'Fecha programación',
                        align: 'center',
                        sortable: false,
                        value: 'FecProgramacion',
						visibleColumn: false,
						component: {
							render: function (createElement) {
								return createElement(
										`span`,
										`${this.value.FecProgramacion ? this.moment(this.value.FecProgramacion).format('YYYY-MM-DD HH:mm') : ''}`
								)
							},
							props: ['value']
						}
                    },
                    {
                        text: 'Prescripción',
                        align: 'left',
                        sortable: true,
                        value: 'NoPrescripcion'
                    },
					{
						text: 'Sede',
						align: 'left',
						sortable: false,
						value: 'sede.nombre',
						visibleColumn: false
					},
					{
						text: 'Municipio Ent.',
						tooltip: 'Municipio de Entrega',
						align: 'left',
						sortable: false,
						value: 'CodMunEnt'
					},
                    {
                        text: 'ServTecEntregar',
                        tooltip: 'Servicio o tecnología a entregar',
                        align: 'center',
                        sortable: false,
                        value: 'TipoTec',
                        classData: 'text-xs-center',
                        component: {
                            render: function (createElement) {
                                return createElement(
                                    `a`,
                                    {
                                        domProps: {
                                            innerHTML: `${this.value.TipoTec} ${this.value.CodSerTecAEntregar}`
                                        },
                                        on: {
                                            click: () => {
                                                $this.getDetalleTechnologi(this.value.TipoTec, this.value.CodSerTecAEntregar)
                                            }
                                        }
                                    }
                                )
                            },
                            props: ['value']
                        }
                    },
                    {
						text: 'Cant.',
						tooltip: 'Cantidad total a entregar',
                        align: 'center',
                        sortable: false,
                        value: 'CantTotAEntregar',
                        classData: 'text-xs-center'
                    },
                    {
                        text: 'Max. entrega',
                        tooltip: 'Fecha maxima de entrega',
                        align: 'left',
                        sortable: true,
                        value: 'FecMaxEnt'
                    },
                    {
                        text: 'Paciente',
                        align: 'left',
                        sortable: false,
                        value: 'NoIDPaciente',
                        component: {
                            render: function (createElement) {
                                return createElement(
                                    `span`,
                                    `${this.value.TipoIDPaciente}${this.value.NoIDPaciente}`
                                )
                            },
                            props: ['value']
                        }
                    },
                    {
                      text: 'EPS',
                      align: 'left',
                      sortable: false,
                      value: 'CodEPS',
                      component: {
                        render: function (createElement) {
                          return createElement(
                            `div`,
                            {
                              domProps: {
                                innerHTML: `
                                  <v-list-tile>
                                    <v-list-tile-content style="display: grid !important;">
                                      <v-list-tile-title class="body-2">${this.value.NoIDEPS}</v-list-tile-title>
                                      <v-list-tile-sub-title class="caption">Código: ${this.value.CodEPS}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                `
                              }
                            }
                          )
                        },
                        props: ['value']
                      }
                    },
                    {
                      text: 'Usuario',
                      tooltip: 'Usuario que registra el último movimiento',
                      align: 'left',
                      sortable: false,
                      visibleColumn: false,
                      value: 'user_id',
                      component: {
                        render: function (createElement) {
                          return createElement(
                            `div`,
                            {
                              domProps: {
                                innerHTML: `
                                  <v-list-tile>
                                    <v-list-tile-content style="display: grid !important;">
                                      <v-list-tile-title class="body-2">${this.value.usuario ? this.value.usuario.name : ''}</v-list-tile-title>
                                      <v-list-tile-sub-title class="caption">${this.value.usuario ? this.value.usuario.email : ''}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                `
                              }
                            }
                          )
                        },
                        props: ['value']
                      }
                    },
                    {
                        text: 'Opciones',
                        align: 'center',
                        sortable: false,
                        actions: true,
                        singlesActions: true,
                        classData: 'text-xs-center'
                    }
                ],
                filters: [
                    {
                        label: 'Fecha Prescripción',
                        type: 'v-range',
                        items: {
                            menuDate: false,
                            type: 'date',
                            range: true,
                            itemMin: {
                                label: 'Inicial',
                                vModel: null,
                                clearable: true,
                                value: 'FecMaxEnt'
                            },
                            itemMax: {
                                menuDate: false,
                                label: 'Final',
                                vModel: null,
                                clearable: true,
                                value: 'FecMaxEnt'
                            }
                        }
                    }
				]
            }
        }),
		computed: {
			sedes() {
				return this.$store.state.general.sedes
			},
            permisos () {
                return this.$store.getters.getPermissionModule('programaciones')
            }
		},
		watch: {
        'sedes' (val) {
			if (val && this.dataTable) this.dataTable.makeHeaders.find(x => x.text === 'Sede').visibleColumn = (val && val.length > 1)
			if (this.$refs && this.$refs.tableProgramaciones) this.$refs.tableProgramaciones.reloadHeaders(val && val.length > 1)
		},
			'processingTable' (val) {
        	if (val !== null || typeof val !== 'undefined') this.dataTable.loading = val
			}
		},
		created () {
            $this = this
		},
		methods: {
          openDialogEntregar (item) {
              this.selectedProgramacion = item
              this.$refs.dialogEntregaProgramacion.open(item)
          },
          getDetalleTechnologi (type, code) {
              this.processingTable = true
              this.$refs.dialogInfoTechnologi.getDetail(type, code)
          },
          cancelProgramacion () {
              this.$refs.dialogCancel.loading()
              this.axios.delete(`programaciones/${this.selectedProgramacion.id}`)
                  .then(response => {
                      this.$refs.tableProgramaciones.reloadPage()
                      this.$store.commit('snackbar', {color: 'success', message: `Se anuló la programación ${this.selectedProgramacion.id} de forma correcta`})
                      this.$refs.dialogCancel.close()
                  }).catch(e => {
                  this.$refs.dialogCancel.loading(false)
                  this.$store.commit('snackbar', {color: 'error', message: `al tratar de anular la programación ${this.selectedProgramacion.id}`, error: e})
              })
          },
          openDialogCancel (item) {
              this.$refs.dialogCancel.open()
              this.selectedProgramacion = item
          },
          async descargarSoporte (item) {
            item.loading = true
            let archivo = {
              url: `direccionamientos/soporte/${item.direccionamiento_id}`
            }
            await this.descargarArchivo(archivo)
            item.loading = false
          },
          resetOptions (item) {
              item.options = []
              if (item.EstProgramacion === 1) item.options.push({event: this.permisos.entregar ? 'entregar' : '', icon: 'ti ti-package', tooltip: this.permisos.entregar ? 'Entregar' : 'Sin permisos para registrar entregas', color: this.permisos.entregar ? 'success' : 'grey', size: 'medium'})
              item.options.push({event: this.generarSoporte ? 'descargarSoporte' : '', icon: 'zmdi zmdi-collection-pdf', tooltip: this.generarSoporte ? 'Descargar Soporte' : 'Sin permisos para descargar el soporte', color: this.generarSoporte ? 'black' : 'grey', size: 'medium'})
              if (item.EstProgramacion === 1) item.options.push({event: this.permisos.anular ? 'anular' : '', icon: 'ti ti-trash', tooltip: this.permisos.anular ? 'Anular' : 'Sin permisos para anular', color: this.permisos.anular ? 'error' : 'grey', size: 'medium'})
              return item
          }
        }
    }
</script>